import name from './name'

const selectSliceData = state => state[name]

const selectTenantMSAConfig = state => selectSliceData(state).msaTenantConfig

export { selectTenantMSAConfig }
